import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, TextKey } from '@mews-commander/enums';
import { CustomerPaymentsTab, PaymentsTabActiveSegment } from '@mews-commander/modules/src/modules/payment';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => (
    <CustomerPaymentsTab accountId={Route.useParams().accountId} activeSegment={PaymentsTabActiveSegment.Methods} />
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Payment/Methods/$accountId')({
    component: Component,
    staticData: {
        owner: MewsTeam.PaymentExperience,
        type: RouteType.Frontend,
        // TODO: should be based on same values as `usePaymentsTabSegmentTitle`, `pendingComponent` option support needed
        title: TextKey.PaymentMethodPlural,
        guideLink: createGuideLink(ArticlePath.TakePayment),
    },
});
